module.exports = __webpack_public_path__ + "img/Certificate.1a8770f4.jpg";